module.exports = __webpack_public_path__ + "img/dots_ltp1.12c4ac61.png";